<script setup>

import {Deferred, usePage} from "@inertiajs/vue3";
import {DatePicker} from "v-calendar";
import {computed, ref} from "vue";
import ReservationCard from "./ReservationCard.vue";

const props = defineProps({
    showAll: Boolean,
    reservations: Array,
})
const getAttributes = (reservations) => {
    return [
        {
            key: 'today',
            dates: new Date(),
            order: 0,
            content: {
                style: {
                    fontWeight: 'bold',
                }
            }
        },
        ...reservations.map((value) => {
            return {
                dot: true,
                color: 'black',
                dates: [
                    {
                        start: new Date(value.date),
                        end: new Date(value.date)
                    }
                ]
            }
        })
    ]
}

const newReservations = computed(() => {
    return props.reservations.filter(reservation => reservation.state === 'pending')
})

const expanded = ref(props.showAll);

const chosenDay = ref(null)
</script>

<template>
    <div class="grow h-full">
        <div
            class="flex rounded-2xl flex-col border dark:border-neutral-700 h-full grow overflow-hidden dark:bg-neutral-900 bg-white shadow"
            style="min-height:300px">
                <div v-if="reservations.length === 0"
                     class="p-2 flex flex-col items-center justify-center h-full gap-2">
                    <i class="pi pi-calendar bg-gray-200 p-4 rounded-xl mb-2" style="font-size: 2rem"></i>
                    <p class="font-bold">{{ $t('dashboard.no_new_reservations') }}</p>
                    <p class="text-gray-700 text-sm">{{ $t('dashboard.no_new_reservations_desc') }}</p>
                </div>
                <template v-else>
                    <div class="border-b dark:border-neutral-700 w-full p-1 !pointer-events-none">
                        <DatePicker v-model="chosenDay" class="reservation-minimap" title-position="left" transparent
                                    expanded is-dark="system" :view="showAll ? 'monthly' : 'weekly'"
                                    :attributes="getAttributes(reservations)" borderless></DatePicker>
                    </div>
                    <div class="relative  overflow-hidden" :class="showAll ? 'h-full': 'reservations-windowlette'">
                        <div class="w-full flex flex-col gap-2 relative h-full">
                            <div v-if="newReservations.length" class="pt-4 p-5 overflow-y-scroll">
                                <p class="text-sm font-bold opacity-80 mb-1">{{ $t('dashboard.pending_reservations_title') }}</p>
                                <template
                                    v-for="(reservation, i) in newReservations"
                                    :key="reservation.id"
                                >
                                    <reservation-card v-if="i < 3 || expanded" :unclickable="i === 2"
                                                      :reservation="reservation"/>
                                </template>
                                <div v-if="!expanded"
                                     class="bg-gradient-to-t from-gray-50 dark:from-gray-900 from-30% text-center absolute bottom-3 p-6 w-full -mx-5 cursor-pointer pointer-events-none"
                                     @click="expanded = true">
                                    <div>
                                        <i class="pi pi-chevron-circle-down mb-1 mt-12"/>
                                        <p>{{ $t('common.show_all') }}</p>
                                    </div>
                                </div>
                            </div>
                            <template v-else>
                                <div
                                    class="flex flex-col justify-center rounded-2xl items-center text-center h-full gap-3 rounded-t-none bg-neutral-100 dark:bg-neutral-800">
                                    <i class="pi pi-thumbs-up -mt-3 !text-2xl"/>
                                    <p class="font-bold">{{ $t('dashboard.no_new_reservations_empty') }}</p>
                                </div>
                            </template>
                        </div>

                        <div v-if="false" class="w-full p-5 pt-4 bg-white dark:bg-black absolute chosen-windowlette top-0"
                             :class="[chosenDay ? 'chosen-windowlette-active': '', showAll ? 'h-full' : ' reservations-windowlette']">
                            <p class="text-sm font-bold opacity-80">{{ $t('dashboard.selected_day') }}</p>
                        </div>
                    </div>

                </template>
        </div>
    </div>
</template>

<style lang="scss">
.reservations-windowlette {
    height: 260px;
}

.chosen-windowlette {
    transition: all .3s ease-in-out;
    left: 124px;
    opacity: 0;
    pointer-events: none;

    &.chosen-windowlette-active {
        opacity: 1;
        pointer-events: auto;
        left: 0;
    }
}

.reservation-minimap .vc-arrow {
    visibility: hidden !important;
}

</style>
